export const treePositions = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
];

export const qrCodeImages = [
  "https://storage.yandexcloud.net/northmemoryhotstore/static/qr-code/img1.png",
  "https://storage.yandexcloud.net/northmemoryhotstore/static/qr-code/img2.webp",
  "https://storage.yandexcloud.net/northmemoryhotstore/static/qr-code/img3.png",
  "https://storage.yandexcloud.net/northmemoryhotstore/static/qr-code/img4.png",
  "https://storage.yandexcloud.net/northmemoryhotstore/static/qr-code/img5.png",
  "https://storage.yandexcloud.net/northmemoryhotstore/static/qr-code/img6.png",
  "https://storage.yandexcloud.net/northmemoryhotstore/static/qr-code/img7.png",
  "https://storage.yandexcloud.net/northmemoryhotstore/static/qr-code/img8.png",
];
